import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs w-4 h-4 flex items-center justify-center"></i>
            )}
            {isLast || !item.path ? (
              <span className="text-foreground-500">{item.label}</span>
            ) : (
              <Link
                to={item.path}
                className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}